export default "__VITE_ASSET__D_YlibDe__"